import { ReactNode } from "react";
import Tab from "components/DesignSystem/Tab/Tab";

export const INVOICE_PANE_TAB = {
  EDIT: "EDIT",
  PREVIEW: "PREVIEW",
} as const;

export type InvoicePaneTab =
  (typeof INVOICE_PANE_TAB)[keyof typeof INVOICE_PANE_TAB];

type MobileInvoicePaneTabsProps = {
  value: InvoicePaneTab;
  onChange: (value: InvoicePaneTab) => void;
  editLabel?: string;
  previewLabel?: string;
  right?: ReactNode;
};

export const MobileInvoicePaneTabs = ({
  value,
  onChange,
  editLabel = "Edit",
  previewLabel = "Preview",
  right,
}: MobileInvoicePaneTabsProps) => {
  const handleChange = (next: string) => onChange(next as InvoicePaneTab);

  return (
    <div className="t-relative">
      <Tab.Root value={value} onValueChange={handleChange}>
        <Tab.List className="!t-mb-0">
          <Tab.Trigger value={INVOICE_PANE_TAB.EDIT}>{editLabel}</Tab.Trigger>
          <Tab.Trigger value={INVOICE_PANE_TAB.PREVIEW}>
            {previewLabel}
          </Tab.Trigger>
        </Tab.List>
      </Tab.Root>
      {right && (
        <div className="t-absolute t-right-0 t-top-2 t-flex t-items-center t-h-6">
          {right}
        </div>
      )}
    </div>
  );
};
